module.exports = __webpack_public_path__ + "static/media/diagram2.0d861761.jpeg";